import { useTranslation } from "next-i18next"
import CONSTANTS from "@/constants"
import parse from "html-react-parser"

const useAuthModali18n = props => {
  const { t } = useTranslation()
  const i18n = {
    createAccountMobileNumber:
      parse(`${props?.createAccountMobileNumber}`) === CONSTANTS.UNDEFINED
        ? t("Mobile Number*")
        : parse(
            `${props?.createAccountMobileNumber}`.replaceAll("&amp;nbsp;", " ")
          ),
    createAccountFormIAgreeText:
      parse(
        `${props?.createAccountFormIAgreeText}`.replaceAll("&amp;nbsp;", " ")
      ) ?? "",
    phoneExists: t(
      "kf.auth.label.createaccount.error.phoneexits",
      "An account already exists with this phone number. Please sign in to access your account."
    ),
    signin:
      parse(`${props?.signIn}`) === CONSTANTS.UNDEFINED
        ? t("Sign In")
        : parse(`${props?.signIn}`.replaceAll("&amp;nbsp;", " ")),
    signinWithOTP:
      parse(`${props?.loginMainTitle}`) === CONSTANTS.UNDEFINED
        ? t("kf.login.signinWithOTP", "sign in with an otp")
        : parse(`${props?.loginMainTitle}`.replaceAll("&amp;nbsp;", " ")),
    createAccount:
      parse(`${props?.createAccount}`) === CONSTANTS.UNDEFINED
        ? t("Create Account")
        : parse(`${props?.createAccount}`.replaceAll("&amp;nbsp;", " ")),
    enterMobileNumber: t("kf.login.enterMobileNumber", "Mobile Number*"),
    getOTP:
      parse(`${props?.loginCtaLabel}`) === CONSTANTS.UNDEFINED
        ? t("kf.login.getOTP", "Get OTP")
        : parse(`${props?.loginCtaLabel}`.replaceAll("&amp;nbsp;", " ")),
    policyText: parse(
      `${props?.loginPrivacyPolicyText}`.replaceAll("&amp;nbsp;", " ")
    ),
    label:
      parse(`${props?.otpFlowScreen2Description}`) === CONSTANTS.UNDEFINED
        ? t("kf.login.label", "A six-digit OTP has been sent to")
        : props?.otpFlowScreen2Description.replace(
            /(<p[^>]+?>|<p>|<\/p>)/gim,
            ""
          ),
    backToSignIn:
      parse(`${props?.loginBackButtonText}`) === CONSTANTS.UNDEFINED
        ? t("kf.login.backToSignIn", "Back To Sign In")
        : parse(`${props?.loginBackButtonText}`.replaceAll("&amp;nbsp;", " ")),
    verifySignIn:
      parse(`${props?.loginScreen2ctaLabel}`) === CONSTANTS.UNDEFINED
        ? t("kf.login.verify", "Verify")
        : parse(`${props?.loginScreen2ctaLabel}`.replaceAll("&amp;nbsp;", " ")),
    otpNotReceived:
      parse(`${props?.loginResendOtpText}`) === CONSTANTS.UNDEFINED
        ? t("kf.login.otpNotReceived", "Your OTP has expired")
        : parse(`${props?.loginResendOtpText}`.replaceAll("&amp;nbsp;", " ")),
    resendOTP:
      parse(`${props?.loginResendOtpLabel}`) === CONSTANTS.UNDEFINED
        ? t("kf.login.resendOTP", "Resend OTP")
        : parse(`${props?.loginResendOtpLabel}`.replaceAll("&amp;nbsp;", " ")),
    tryAgain:
      parse(`${props?.loginExceededAttemptText}`) === CONSTANTS.UNDEFINED
        ? t("kf.login.tryAgain", "Please try again in 15 minutes")
        : parse(
            `${props?.loginExceededAttemptText}`.replaceAll("&amp;nbsp;", " ")
          ),
    exitConfirmation:
      parse(`${props?.loginConfirmationText}`) === CONSTANTS.UNDEFINED
        ? t(
            "kf.login.exitConfirmation",
            "Are you sure you want to leave this section?"
          )
        : parse(
            `${props?.loginConfirmationText}`.replaceAll("&amp;nbsp;", " ")
          ),
    yes: t("kf.contactus.label.yes", "Yes"),
    no: t("kf.contactus.label.no", "No"),
    tryagainmin: t("kf.login.tryAgainmin", "Please try again in 5 minutes"),
    errorPhoneNumber: t(
      "kf.login.errorPhoneNumber",
      "Please enter a valid mobile number"
    ),
    viewFavoritesLogin: t(
      "kf.login.viewFavoritesLogin",
      "Please sign-in to manage your favorites"
    ),
    signinDescription: t(
      "kf.signin.desc",
      "Please ensure you provide a valid mobile number."
    ),
    invalidOTP:
      parse(`${props?.loginOtpErrorMessage}`) === CONSTANTS.UNDEFINED
        ? t("kf.login.invalidOTP", "OTP is invalid or no longer active")
        : parse(`${props?.loginOtpErrorMessage}`.replaceAll("&amp;nbsp;", " ")),

    mobileDescription: t(
      "kf.auth.label.createaccount.mobileDescription",
      "Enter the six-digit code sent to "
    ),
    resend: t("kf.auth.label.createaccount.resend", "Resend OTP"),
    otpexpire: t("kf.signin.otpexpire", "Your OTP will expire in "),
    receiveOTP: t(
      "kf.auth.label.createaccount.receiveOTP",
      "Your OTP has expired"
    ),
    getOTP: t("kf.auth.label.createaccount.getOTP", "Get OTP"),
    verify: t("kf.auth.label.createaccount.verify", "Verify"),
    errorOTP: t(
      "kf.auth.label.createaccount.verifyOTP",
      "OTP is not valid. Please enter a valid OTP to continue."
    ),
    exceedlimit: t(
      "kf.auth.label.createaccount.exceedlimit",
      "You have exceeded limit for OTP attempts."
    ),
    changeNumber:
      parse(`${props?.otpFlowScreen2MobilePlaceholder}`) === CONSTANTS.UNDEFINED
        ? t("kf.login.changeNumber", "Edit number")
        : parse(
            `${props?.otpFlowScreen2MobilePlaceholder}`.replaceAll(
              "&amp;nbsp;",
              " "
            )
          ),
    backToCreate: t(
      "kf.auth.label.createaccount.backToCreateAccount",
      "Back to Create Account"
    ),
    createTitle: t(
      "kf.auth.label.createaccount.title",
      "Create an account with your mobile number"
    ),
    termsCondition: t("kf.auth.label.createaccount.terms"),
    signin:
      parse(`${props?.signIn}`) === CONSTANTS.UNDEFINED
        ? t("Sign In")
        : parse(`${props?.signIn}`.replaceAll("&amp;nbsp;", " ")),
    createAccount:
      parse(`${props?.createAccount}`) === CONSTANTS.UNDEFINED
        ? t("Create Account")
        : parse(`${props?.createAccount}`.replaceAll("&amp;nbsp;", " ")),
    createYourAccount:
      parse(`${props?.createAccountFormTitle}`) === CONSTANTS.UNDEFINED
        ? t("kf.auth.label.createYourAccount", "Create Your Account")
        : parse(
            `${props?.createAccountFormTitle}`.replaceAll("&amp;nbsp;", " ")
          ),
    email: t("kf.auth.label.email", "Email"),
    password: t("kf.auth.label.password", "Password"),
    homeowneremail:
      parse(`${props?.homeowneremail}`) === CONSTANTS.UNDEFINED
        ? t("kf.auth.label.emailAddress", "Email Address*")
        : parse(`${props?.homeowneremail}`.replaceAll("&amp;nbsp;", " ")),
    homeownerpassword:
      parse(`${props?.homeownerpassword}`) === CONSTANTS.UNDEFINED
        ? t("kf.auth.label.homeownerpassword", "Password*")
        : parse(`${props?.homeownerpassword}`.replaceAll("&amp;nbsp;", " ")),
    forgotPassword: t("kf.auth.label.forgotPassword", "Forgot password?"),
    keepMeLoggedIn:
      parse(`${props?.keepMeLoggedIn}`) === CONSTANTS.UNDEFINED
        ? t("kf.auth.label.keepMeLoggedIn", "Keep me logged in")
        : parse(`${props?.keepMeLoggedIn}`.replaceAll("&amp;nbsp;", " ")),
    loginWithFacebook: t(
      "kf.auth.label.loginWithFacebook",
      "Continue with Facebook"
    ),
    loginWithGoogle: t("kf.auth.label.loginWithGoogle", "Continue with Google"),
    loginWithApple: t("kf.auth.label.loginWithApple", "Continue with Apple"),
    createAccountDesc:
      parse(`${props?.createAccountDesc}`) === CONSTANTS.UNDEFINED
        ? t(
            "kf.auth.label.createAccountDesc",
            "Creating your Kohler account provides benefits across all of our brands:"
          )
        : parse(`${props?.createAccountDesc}`.replaceAll("&amp;nbsp;", " ")),
    subjectAccessReq:
      parse(`${props?.subjectAccessReq}`) === CONSTANTS.UNDEFINED
        ? t("kf.auth.label.subjectAccessReq", "Subject Access Request")
        : parse(`${props?.subjectAccessReq}`.replaceAll("&amp;nbsp;", " ")),
    homeOwnerAccount:
      parse(`${props?.homeOwnerAccount}`) === CONSTANTS.UNDEFINED
        ? t("kf.auth.label.homeOwnerAccount", "Homeowner Account")
        : parse(`${props?.homeOwnerAccount}`.replaceAll("&amp;nbsp;", " ")),
    homeOwnerAccountDesc:
      parse(`${props?.homeOwnerAccountDesc}`) === CONSTANTS.UNDEFINED
        ? t(
            "kf.auth.label.homeOwnerAccountDesc",
            "For individual customers planning and purchasing for their home."
          )
        : parse(`${props?.homeOwnerAccountDesc}`.replaceAll("&amp;nbsp;", " ")),
    professionalAccount:
      parse(`${props?.professionalAccount}`) === CONSTANTS.UNDEFINED
        ? t("kf.auth.label.professionalAccount", "Professional Account")
        : parse(`${props?.professionalAccount}`.replaceAll("&amp;nbsp;", " ")),
    professionalAccountDesc: parse(`${props?.professionalAccountDesc}`)
      ? t(
          "kf.auth.label.professionalAccountDesc",
          "For residential and commercial construction industry and business needs."
        )
      : parse(
          `${props?.professionalAccountDesc}`.replaceAll("&amp;nbsp;", " ")
        ),
    privacyPolicy:
      parse(`${props?.privacypolicy}`) === CONSTANTS.UNDEFINED
        ? t("kf.auth.label.privacyPolicy", "Privacy Policy")
        : parse(`${props?.privacypolicy}`.replaceAll("&amp;nbsp;", " ")),
    termsOfService:
      parse(`${props?.termsofservice}`) === CONSTANTS.UNDEFINED
        ? t("kf.auth.label.termsOfService", "Terms of Service")
        : parse(`${props?.termsofservice}`.replaceAll("&amp;nbsp;", " ")),
    personalRecommendations:
      parse(`${props?.recommendations}`) === CONSTANTS.UNDEFINED
        ? t(
            "kf.auth.label.personalRecommendations",
            "Personalized recommendations"
          )
        : parse(`${props?.recommendations}`.replaceAll("&amp;nbsp;", " ")),
    accessToFeatures:
      parse(`${props?.projectplanningfeatures}`) === CONSTANTS.UNDEFINED
        ? t(
            "kf.auth.label.accessToFeatures",
            "Access to project planning features"
          )
        : parse(
            `${props?.projectplanningfeatures}`.replaceAll("&amp;nbsp;", " ")
          ),
    savePaymentsAndAddress:
      parse(`${props?.preferences}`) === CONSTANTS.UNDEFINED
        ? t("kf.auth.label.savePaymentsAndAddress", "Save preferences")
        : parse(`${props?.preferences}`.replaceAll("&amp;nbsp;", " ")),
    quickCheckout:
      parse(`${props?.checkoutfaster}`) === CONSTANTS.UNDEFINED
        ? t("kf.auth.label.quickCheckout", "Check out faster")
        : parse(`${props?.checkoutfaster}`.replaceAll("&amp;nbsp;", " ")),
    easyOrderTracking:
      parse(`${props?.easilytrackorders}`) === CONSTANTS.UNDEFINED
        ? t("kf.auth.label.easyOrderTracking", "Easily track orders")
        : parse(`${props?.easilytrackorders}`.replaceAll("&amp;nbsp;", " ")),
    requiredFields:
      parse(`${props?.fieldnamerequired}`) === CONSTANTS.UNDEFINED
        ? t(
            "kf.auth.label.requiredFields",
            "Fields marked with * are required."
          )
        : parse(`${props?.fieldnamerequired}`.replaceAll("&amp;nbsp;", " ")),
    validEmail:
      parse(`${props?.homeowneremailError}`) === CONSTANTS.UNDEFINED
        ? t("kf.auth.error.validEmail", "Please enter a valid email address.")
        : parse(`${props?.homeowneremailError}`.replaceAll("&amp;nbsp;", " ")),
    professionalaccemailError:
      parse(`${props?.professionalaccemailError}`) === CONSTANTS.UNDEFINED
        ? t("kf.auth.error.validEmail", "Please enter a valid email address.")
        : parse(
            `${props?.professionalaccemailError}`.replaceAll("&amp;nbsp;", " ")
          ),
    validPassword: t(
      "kf.auth.error.validPassword",
      "Please enter a valid password."
    ),
    invalidEmailOrPassword:
      parse(`${props?.invalidEmailOrPassword}`) === CONSTANTS.UNDEFINED
        ? t(
            "kf.auth.error.invalidEmailOrPassword",
            "Sorry, the email or password you've provided does not match our records. Please try again."
          )
        : parse(
            `${props?.invalidEmailOrPassword}`.replaceAll("&amp;nbsp;", " ")
          ),
    lockedOut: t(
      "kf.auth.error.lockedOut",
      "You have exceeded the permitted number of failed login attempts. To access your account, please reset your password."
    ),
    contactSupport: t("kf.auth.error.contactSupport", "contact support."),
    mobileLabel: t(
      "kf.auth.label.createaccount.mobileNumber",
      "Mobile Number*"
    ),
    mobilenumber: t(
      "kf.auth.label.createaccount.mobilenumber",
      "Mobile Number*"
    ),
    fnameError:
      parse(`${props?.homeownerfirstnameError}`) === CONSTANTS.UNDEFINED
        ? t("kf.auth.error.fnameErrorNew", "Your first name is required.")
        : parse(
            `${props?.homeownerfirstnameError}`.replaceAll("&amp;nbsp;", " ")
          ),
    professionalaccfirstnameError:
      parse(`${props?.professionalaccfirstnameError}`) === CONSTANTS.UNDEFINED
        ? t("kf.auth.error.fnameErrorNew", "Your first name is required.")
        : parse(
            `${props?.professionalaccfirstnameError}`.replaceAll(
              "&amp;nbsp;",
              " "
            )
          ),
    lnameError:
      parse(`${props?.homeownerLastNameError}`) === CONSTANTS.UNDEFINED
        ? t("kf.auth.error.lnameError", "Your last name is required.")
        : parse(
            `${props?.homeownerLastNameError}`.replaceAll("&amp;nbsp;", " ")
          ),
    professionalacclastnameError:
      parse(`${props?.professionalacclastnameError}`) === CONSTANTS.UNDEFINED
        ? t("kf.auth.error.lnameError", "Your last name is required.")
        : parse(
            `${props?.professionalacclastnameError}`.replaceAll(
              "&amp;nbsp;",
              " "
            )
          ),
    passwordError:
      parse(`${props?.homeownerpasswordError}`) === CONSTANTS.UNDEFINED
        ? t(
            "kf.auth.error.passwordError",
            "Your password must contain at least 10 characters, 1 uppercase letter, 1 lowercase letter, 1 number, and 1 symbol (!@#$%^&*).  Password should not contain username, common words, first or last name, email id domain name or any of your last 4 passwords."
          )
        : parse(
            `${props?.homeownerpasswordError}`.replaceAll("&amp;nbsp;", " ")
          ),
    passwordMatchError:
      parse(`${props?.passwordMismatcherror}`) === CONSTANTS.UNDEFINED
        ? t(
            "kf.auth.error.passwordMatchError",
            "New & Re-Enter passwords do not match."
          )
        : parse(
            `${props?.passwordMismatcherror}`.replaceAll("&amp;nbsp;", " ")
          ),
    zipcodeError: t(
      "kf.auth.error.zipcodeError",
      "Please provide your business zipcode."
    ),
    validZipcode: t(
      "kf.auth.error.validZipcode",
      "Please enter a valid zipcode."
    ),
    businessTypeError: t(
      "kf.auth.error.businessTypeError",
      "Please provide your business type."
    ),
    subTypeError: t(
      "kf.auth.error.subTypeError",
      "Please provide your account sub-type."
    ),
    homeownerfirstname:
      parse(`${props?.homeownerfirstname}`) === CONSTANTS.UNDEFINED
        ? t("kf.auth.label.firstName", "First Name*")
        : parse(`${props?.homeownerfirstname}`.replaceAll("&amp;nbsp;", " ")),
    homeownerLastName:
      parse(`${props?.homeownerLastName}`) === CONSTANTS.UNDEFINED
        ? t("kf.auth.label.lastName", "Last Name*")
        : parse(`${props?.homeownerLastName}`.replaceAll("&amp;nbsp;", " ")),
    zipcode: t("kf.auth.label.zipcode", "Business ZIP Code"),
    companyName: t("kf.auth.label.companyName", "Company Name*"),
    companyNameError:
      parse(`${props?.companyNameError}`) === CONSTANTS.UNDEFINED
        ? t("kf.auth.label.companyNameError", "Please enter your company name.")
        : parse(`${props?.companyNameError}`.replaceAll("&amp;nbsp;", " ")),
    companyNameAlphanumericError:
      parse(`${props?.companyNameAlphanumericError}`) === CONSTANTS.UNDEFINED
        ? t(
            "kf.auth.label.companyNameAlphanumericError",
            "Please enter only alphanumeric and safe characters."
          )
        : parse(
            `${props?.companyNameAlphanumericError}`.replaceAll(
              "&amp;nbsp;",
              " "
            )
          ),
    emailAddress: t("kf.auth.label.emailAddress", "Email Address*"),
    passwordRequirements:
      parse(`${props?.passwordRequirements}`) === CONSTANTS.UNDEFINED
        ? t("kf.auth.label.passwordRequirements", "Password Requirements")
        : parse(`${props?.passwordRequirements}`.replaceAll("&amp;nbsp;", " ")),
    primaryBusinessType: t(
      "kf.auth.label.primaryBusinessType",
      "Primary Business Type"
    ),
    accountSubType: t("kf.auth.label.accountSubType", "Account Sub-Type"),
    signupForNewsletter:
      parse(`${props?.newsletterSignUp}`) === CONSTANTS.UNDEFINED
        ? t(
            "kf.auth.label.signupForNewsletter",
            "Sign me up for the e-newsletter"
          )
        : parse(`${props?.newsletterSignUp}`.replaceAll("&amp;nbsp;", " ")),
    alreadyHaveAccount:
      parse(`${props?.alreadyHaveAnAccount}`) === CONSTANTS.UNDEFINED
        ? t("kf.auth.label.alreadyHaveAccount", "Already have an account? ")
        : parse(`${props?.alreadyHaveAnAccount}`.replaceAll("&amp;nbsp;", " ")),
    pwMustInclude:
      parse(`${props?.authorablepassworddialog}`) === CONSTANTS.UNDEFINED
        ? t("kf.auth.label.pwMustInclude", "Password must include:")
        : parse(
            `${props?.authorablepassworddialog}`.replaceAll("&amp;nbsp;", " ")
          ),
    showDialog: false,
    welcomeTo: props?.hi ?? t("kf.auth.label.welcomeTo", "Welcome to Kohler"),
    welcomeMessage: props?.accountSuccessDesc,
    checkoutWelcomeMessage: t(
      "kf.auth.label.welcomeMessage",
      "Get the most out of your new Kohler account by completing your profile."
    ),
    finishProfile: t("kf.auth.label.finishProfile", "Finish my profile"),
    accountSuccessCTA: props?.accountSuccessCTA,
    accountSuccessLink: props?.accountSuccessLink,
    continueShopping: t("kf.auth.label.continueShopping", "Continue Shopping"),
    sendEmail: t("kf.auth.label.sendEmail", "Send Email"),
    resendEmail: t("kf.auth.label.resendEmail", "Resend Email"),
    continueShipping: t(
      "kf.checkout.label.continuetoshipping",
      "Continue to Shipping"
    ),
    otpDescription: t(
      "kf.checkout.label.customerInstruction",
      'Mobile number verification required via one-time password. Enter a valid mobile number and then click "Get OTP" to get a six-digit code sent to your mobile device.'
    ),
    backToSignin:
      parse(`${props?.backToSignIn}`) === CONSTANTS.UNDEFINED
        ? t("kf.auth.label.backToSignin", "Back to Sign In")
        : parse(`${props?.backToSignIn}`.replaceAll("&amp;nbsp;", " ")),
    resetPassword:
      parse(`${props?.resetPasswordTitle}`) === CONSTANTS.UNDEFINED
        ? t("kf.auth.label.resetPassword", "Reset Your Password")
        : parse(`${props?.resetPasswordTitle}`.replaceAll("&amp;nbsp;", " ")),
    mailSent:
      parse(`${props?.resetPasswordStep2Title}`) === CONSTANTS.UNDEFINED
        ? t("kf.auth.label.mailSent", "Your email has been sent.")
        : parse(
            `${props?.resetPasswordStep2Title}`.replaceAll("&amp;nbsp;", " ")
          ),
    checkEmail:
      parse(`${props?.resetPasswordStep2Desc}`) === CONSTANTS.UNDEFINED
        ? t(
            "kf.auth.label.checkEmail",
            "Please check your email for instructions to reset your password."
          )
        : parse(
            `${props?.resetPasswordStep2Desc}`.replaceAll("&amp;nbsp;", " ")
          ),
    forgotPasswordDesc:
      parse(`${props?.resetPasswordDesc}`) === CONSTANTS.UNDEFINED
        ? t(
            "kf.auth.label.forgotPasswordDesc",
            "Enter the email address associated with your account, and we will send you an email with a link to reset your password."
          )
        : parse(`${props?.resetPasswordDesc}`.replaceAll("&amp;nbsp;", " ")),
    emailAlreadyExists: t(
      "kf.auth.error.emailAlreadyExists",
      "An account already exists for this email. Please sign in."
    ),
    submit: t("kf.auth.label.submit", "Submit"),
    close: t("kf.auth.label.close", "Close"),
    signinAria: t(
      "kf.auth.label.signinAria",
      "Sign in. Tap or click here to sign in."
    ),
    createAccountAria: t(
      "kf.auth.label.createAccountAria",
      "Create an account. Tap or click here to create an account."
    ),
    homeOwnerAria: t(
      "kf.auth.label.homeOwnerAria",
      "Home-owner create account"
    ),
    proAccountAria: t(
      "kf.auth.label.proAccountAria",
      "Professional create account"
    ),
    authModalAria: t(
      "kf.auth.label.authModalAria",
      "You are on Sign-in / Create an account modal window."
    ),
    signupModalAria: t(
      "kf.auth.label.signupModalAria",
      "You are on Create Account modal window."
    ),
    forgotPwdModalAria: t(
      "kf.auth.label.forgotPwdModalAria",
      "You are on forgot password modal window."
    ),
    welcomeAria: t("kf.auth.label.welcomeAria", "Account created succesfully"),
    pwdError:
      parse(`${props?.homeownerpasswordError}`) === CONSTANTS.UNDEFINED
        ? t("kf.auth.label.provide.pwdError", "Please provide the Password.")
        : parse(
            `${props?.homeownerpasswordError}`.replaceAll("&amp;nbsp;", " ")
          ),
    reEnterPwdError:
      parse(`${props?.homeownerreenterpasswordError}`) === CONSTANTS.UNDEFINED
        ? t(
            "kf.auth.label.provide.reEnterPwdError",
            "Please provide the Re-enter password."
          )
        : parse(
            `${props?.homeownerreenterpasswordError}`.replaceAll(
              "&amp;nbsp;",
              " "
            )
          ),
    professionalaccpasswordError:
      parse(`${props?.professionalaccpasswordError}`) === CONSTANTS.UNDEFINED
        ? t("kf.auth.label.provide.pwdError", "Please provide the Password.")
        : parse(
            `${props?.professionalaccpasswordError}`.replaceAll(
              "&amp;nbsp;",
              " "
            )
          ),
    professionalaccreenterpasswordError:
      parse(`${props?.professionalaccreenterpasswordError}`) ===
      CONSTANTS.UNDEFINED
        ? t("kf.auth.label.provide.pwdError", "Please provide the Password.")
        : parse(
            `${props?.professionalaccreenterpasswordError}`.replaceAll(
              "&amp;nbsp;",
              " "
            )
          ),
    signinOrSignup: t(
      "kf.cart.label.signinOrSignup",
      "Sign In / Create Account"
    ),
    generalAuthenticationError: t(
      "kf.auth.error.generalAuthenticationError",
      "We have technical difficulties at this time, please try again later."
    ),
    homeOwnerAccountCTA:
      parse(`${props?.homeOwnerAccountCTA}`) === CONSTANTS.UNDEFINED
        ? t("Create Account")
        : parse(`${props?.homeOwnerAccountCTA}`.replaceAll("&amp;nbsp;", " ")),
    professionalAccountCTA:
      parse(`${props?.professionalAccountCTA}`) === CONSTANTS.UNDEFINED
        ? t("Create Account")
        : parse(
            `${props?.professionalAccountCTA}`.replaceAll("&amp;nbsp;", " ")
          ),
    proUserWelcomeMsg: t(
      "kf.auth.label.proUserWelcomeMessage",
      "You are being redirected to an external website."
    ),
    proUserSuccessCTA: t(
      "kf.auth.label.proUserSuccessCTA",
      "Continue to Trade Programs"
    ),
    professionalaccfirstname:
      parse(`${props?.professionalaccfirstname}`) === CONSTANTS.UNDEFINED
        ? t("kf.auth.label.firstName", "First Name*")
        : parse(
            `${props?.professionalaccfirstname}`.replaceAll("&amp;nbsp;", " ")
          ),
    professionalacclastname:
      parse(`${props?.professionalacclastname}`) === CONSTANTS.UNDEFINED
        ? t("kf.auth.label.lastName", "Last Name*")
        : parse(
            `${props?.professionalacclastname}`.replaceAll("&amp;nbsp;", " ")
          ),
    professionalaccemail:
      parse(`${props?.professionalaccemail}`) === CONSTANTS.UNDEFINED
        ? t("kf.auth.label.emailAddress", "Email Address*")
        : parse(`${props?.professionalaccemail}`.replaceAll("&amp;nbsp;", " ")),
    signinhyperlink:
      `${props?.signinhyperlink}` === CONSTANTS.UNDEFINED
        ? ""
        : `${props?.signinhyperlink}`,
    homeownerreenterpassword:
      parse(`${props?.homeownerreenterpassword}`) === CONSTANTS.UNDEFINED
        ? t("kf.auth.label.reEnterPassword", "Re-Enter Password*")
        : parse(
            `${props?.homeownerreenterpassword}`.replaceAll("&amp;nbsp;", " ")
          ),
    professionalaccpassword:
      parse(`${props?.professionalaccpassword}`) === CONSTANTS.UNDEFINED
        ? t("kf.auth.label.homeownerpassword", "Password*")
        : parse(
            `${props?.professionalaccpassword}`.replaceAll("&amp;nbsp;", " ")
          ),
    professionalaccreenterpassword:
      parse(`${props?.professionalaccreenterpassword}`) === CONSTANTS.UNDEFINED
        ? t("kf.auth.label.reEnterPassword", "Re-Enter Password*")
        : parse(
            `${props?.professionalaccreenterpassword}`.replaceAll(
              "&amp;nbsp;",
              " "
            )
          ),
    signInValidEmail:
      parse(`${props?.invalidEmail}`) === CONSTANTS.UNDEFINED
        ? t("kf.auth.error.validEmail", "Please enter a valid email address.")
        : parse(`${props?.invalidEmail}`.replaceAll("&amp;nbsp;", " ")),
    regexForSiginPassword: parse(
      `${props?.regexForPassword}`.replaceAll("&amp;nbsp;", " ")
    ),
    maxStock: quantity =>
      `Only ${quantity} items available in stock. Please update the quantity to proceed.`,
    existEmailAddress: mobileNo =>
      t(
        "kf.checkout.label.existEmail",
        { mobileNo },
        `Sorry this email address is already in use. Please provide the correct mobile number XXXXX XX${mobileNo} to use this email address. Alternatively, you can create a new account by using a different email address."),
    errorMobileNumber: t("kf.customerSupport.error.validMobileNumber`
      ),
    confirmationmodal: t("kf.checkout.label.confirmationmodal"),
    signinPasswordFormatError: parse(
      `${props?.passwordFormatError}`.replaceAll("&amp;nbsp;", " ")
    ),
    createAccountPrivacyPolicy: parse(
      `${props?.createAccountScreen2PrivacyPoilcy}`.replaceAll(
        "&amp;nbsp;",
        " "
      )
    ),
    verifyMobileNumber:
      parse(`${props?.otpFlowDescription}`) === CONSTANTS.UNDEFINED
        ? t(
            "kf.customerSupport.message.verifyPhone",
            "Please verify your mobile number"
          )
        : parse(`${props?.otpFlowDescription}`.replaceAll("&amp;nbsp;", " ")),
    mobileVerification:
      parse(`${props?.otpFlowMainTitle}`) === CONSTANTS.UNDEFINED
        ? t("kf.otpFLow.mobileVerification", "Mobile Number Verification")
        : parse(`${props?.otpFlowMainTitle}`.replaceAll("&amp;nbsp;", " ")),
    verificationTitle: t(
      "kf.auth.label.verificationTitle",
      "Mobile number verification"
    ),
    otpTitle: t(
      "kf.otpFlow.otpTitle",
      "Please enter the OTP to verify your mobile number"
    ),
    changeMobileTitle: t(
      "kf.otpFlow.changeMobileTitle",
      "Please enter a valid mobile number"
    ),
    changeMobileDescription: t(
      "kf.login.changeMobileDescription",
      "A six-digit OTP will then be sent to your device."
    ),
    verificationDescription: "kf.auth.label.verificationDescription",
    signupTtile: t("kf.auth.label.signupTitle", "CUSTOMER Information"),
    updateNumber: t("kf.otpFlow.updateNumber", "Change Mobile Number"),
    numberAlreadyExists: t(
      "kf.otpFlow.numberAlreadyExists",
      "An account already exists with this number."
    ),
    numberNotRegistered: t(
      "kf.auth.label.numberNotRegistered",
      "Mobile Number not registered. Please try"
    ),
    mobileNumber: t("kf.otpFlow.mobileNumber", "Mobile Number*"),
    close: t("kf.findStoreUtilNav.label.closeAlt", "Close"),
    numberNotRegistered: t(
      "kf.auth.label.numberNotRegistered",
      "Mobile Number not registered. Please try"
    ),
    creatingAnAccount: t(
      "kf.auth.label.creatingAnAccount",
      "creating an Account"
    ),
    otpSentDescription:
      parse(`${props?.sixDigitOtpText}`) === CONSTANTS.UNDEFINED
        ? t("kf.otpFlow.otpSentDescription", "A six-digit OTP has been sent to")
        : parse(`${props?.sixDigitOtpText}`.replaceAll("&amp;nbsp;", " ")),
    changeMobileNumberText:
      parse(`${props?.changeMobileNumberText}`) === CONSTANTS.UNDEFINED
        ? t("kf.otpFlow.changeMobileNumberText", "Change mobile number")
        : parse(
            `${props?.changeMobileNumberText}`.replaceAll("&amp;nbsp;", " ")
          ),
    otpExpirationTime:
      parse(`${props?.otpExpireDurationText}`) === CONSTANTS.UNDEFINED
        ? t("kf.otpFlow.otpExpirationTime", "Your OTP will expire in")
        : parse(
            `${props?.otpExpireDurationText}`.replaceAll("&amp;nbsp;", " ")
          ),
    otpExpirationText:
      parse(`${props?.otpExpirationText}`) === CONSTANTS.UNDEFINED
        ? t("kf.otpFlow.otpExpirationText", "Your OTP has expired")
        : parse(`${props?.otpExpirationText}`.replaceAll("&amp;nbsp;", " ")),
    otpInvalidText:
      parse(`${props?.otpInvalidText}`) === CONSTANTS.UNDEFINED
        ? t(
            "kf.otpFlow.otpInvalidText",
            "OTP is not valid. Please enter a valid OTP to continue."
          )
        : parse(`${props?.otpInvalidText}`.replaceAll("&amp;nbsp;", " ")),
    limitExceededText:
      parse(`${props?.limitExceededText}`) === CONSTANTS.UNDEFINED
        ? t(
            "kf.otpFlow.limitExceededText",
            "You have exceeded limit for OTP attempts."
          )
        : parse(`${props?.limitExceededText}`.replaceAll("&amp;nbsp;", " ")),
    otpCantSendText:
      parse(`${props?.otpCantSendText}`) === CONSTANTS.UNDEFINED
        ? t("kf.otpFlow.otpCantSendText", "A six digit OTP can not be sent to")
        : parse(`${props?.otpCantSendText}`.replaceAll("&amp;nbsp;", " ")),
    tryAgainText:
      parse(`${props?.tryAgainText}`) === CONSTANTS.UNDEFINED
        ? t("kf.otpFlow.tryAgainText", "at this time. Please try again later.")
        : parse(`${props?.tryAgainText}`.replaceAll("&amp;nbsp;", " ")),
    mobileNumberChangedSuccessText:
      parse(`${props?.mobileNumberChangedSuccessText}`) === CONSTANTS.UNDEFINED
        ? t(
            "kf.otpFlow.mobileNumberChangedSuccessText",
            "You have successfully changed your mobile number."
          )
        : parse(
            `${props?.mobileNumberChangedSuccessText}`.replaceAll(
              "&amp;nbsp;",
              " "
            )
          ),
    profileCompletionText:
      parse(`${props?.profileCompletionText}`) === CONSTANTS.UNDEFINED
        ? t(
            "kf.otpFlow.profileCompletionText",
            "Get the most ouf of your new Kohler account by completing your profile."
          )
        : parse(
            `${props?.profileCompletionText}`.replaceAll("&amp;nbsp;", " ")
          ),
    viewMyAccountText:
      parse(`${props?.viewMyAccountText}`) === CONSTANTS.UNDEFINED
        ? t("kf.otpFlow.viewMyAccountText", "View my Account")
        : parse(`${props?.viewMyAccountText}`.replaceAll("&amp;nbsp;", " ")),
    noEmailError: t(
      "kf.contactus.error.noEmailError",
      "Please provide your email address"
    ),
    activateAccountTitle: t(
      "kf.otpFlow.activateAccountTitle",
      "Activate your account"
    ),
    activateAccountDesc: t(
      "kf.otpFlow.activateAccountDesc",
      "Complete the following OTP to link your KOHLER account. You'll then recive another OTP to sign in. A six-digit OTP has been sent to"
    ),
    activateAccountCta: t(
      "kf.otpFlow.activateAccountCta",
      "Activate My Account"
    ),
  }
  if (
    i18n.pwMustInclude ===
    t("kf.auth.label.pwMustInclude", "Password must include:")
  ) {
    i18n.showDialog = true
    i18n.characterCount = t(
      "kf.auth.label.characterCount",
      "10 or more characters"
    )
    i18n.uppercaseLetter = t(
      "kf.auth.label.uppercaseLetter",
      "1 Uppercase letter"
    )
    i18n.lowercaseLetter = t(
      "kf.auth.label.lowercaseLetter",
      "1 Lowercase letter"
    )
    i18n.symbolValidation = t(
      "kf.auth.label.symbolValidation",
      "1 Symbol: (ex. $#!@*&)"
    )
    i18n.numberValidation = t("kf.auth.label.numberValidation", "1 Number")
  }
  return i18n
}
export default useAuthModali18n
